export const SET_LOCALE = "SET_LOCALE:";
